import {
  alertBadgeTranslationsBundle,
  Translator,
} from "@fds/wm-typescript-poc-waap-localization-translations";
import { AlertBadgeStoreModuleFactory } from "@fds/wm-typescript-poc-waap-stores-mdg2";
import { alertBadgePlugin } from "@fds/wm-typescript-poc-waap-library";
import { formatters } from "@/helpers/formatters";
import {
  LogLevel,
  ConsoleLogger,
  Mdg2Client,
} from "@fds/wm-typescript-mdg2-client";
import store from "@/store";
import { WidgetConfig } from "./index";

const logger = new ConsoleLogger("AlertBadge");
logger.setLevel(LogLevel.SILENT);

export default (mdg2Client: Mdg2Client) => {
  return <WidgetConfig>{
    name: alertBadgePlugin,
    options: {
      translator: new Translator({
        translations: alertBadgeTranslationsBundle,
      }),
      storeModule: new AlertBadgeStoreModuleFactory({
        mdg2Client,
        logger,
        store,
        options: {
          endpointConfiguration: {
            defaultVersion: "v4",
          },
        },
      }),
      ...formatters,
      logger,
    },
  };
};
